<template>
  <div class="container">
    <div class="container__liner">
      <div class="catalog">
        <div class="catalog__pack">
          <div class="catalog__sidebar">
            <div
                v-if="categories"
                class="catalog__sidebar-sections accordion"
            >
              <div
                  class="catalog__sidebar-item"
                  v-for="(tab, index) in categories"
                  :class="{ __active : isSidebarTabOpen(tab) }"
                  :key="index"
              >
                <a
                  :href='`/catalog/${tab.id}`'
                  class="accordion__head"
                >
                  {{ tab.title }}
                  <span
                      v-if="hasChildren(tab)"
                      class="accordion__head_switcher"
                      @click.prevent.stop="showMoreTabs($event, tab)"
                  ></span>
                </a>
                <div v-if="hasChildren(tab)" class="accordion__content">
                  <a
                      v-for="(type, index) in tab.child"
                      :key="index"
                      :href="'/catalog/' + type.id"
                      class="catalog__sidebar-child"
                      :class="{ 'catalog__sidebar-child_current': getCurrentTab(type, true) }"
                  >
                    {{type.title}}
                  </a>
                </div>
              </div>
            </div>
            <div class="catalog__sidebar-aside">
              <a href="/map" class="catalog__sidebar-pointer attractive"> Где купить/заменить </a>
            </div>
          </div>
          <div class="catalog__main">

            <div v-if="loading" class="loader loader-catalog-list">
              <div class="box box-flex" style="margin-bottom: 50px">
                <div class="item load-skeleton" style="height: 35px"></div>
                <div class="item item-flex" style="height: 400px">
                  <div class="item item-full item-col-3 load-skeleton"></div>
                  <div class="item item-full item-col-3 load-skeleton"></div>
                  <div class="item item-full item-col-3 load-skeleton"></div>
                </div>
                <div class="item item-flex" style="height: 400px">
                  <div class="item item-full item-col-3 load-skeleton"></div>
                  <div class="item item-full item-col-3 load-skeleton"></div>
                  <div class="item item-full item-col-3 load-skeleton"></div>
                </div>
              </div>
            </div>

            <template v-else>
              <h1 class="catalog__main-title">
                {{ catalogH1 }}
              </h1>

              <div
                  class="catalog__main-description"
                  v-if="description.content"
              >
                <div v-html="description.content">
                  <!-- Описание категории -->

                </div>
              </div>

              <div
                class="catalog__main-search uk-margin uk-flex uk-flex-wrap"
              >
                <input
                  class="uk-width-1-3@l uk-width-1-1 uk-input uk-margin uk-margin-right"
                  placeholder="TCL Power Coolant, PC2-CR"
                  v-model="input"
                />
                <div class="catalog__main-buttons uk-margin-bottom">
                  <button
                    :disabled="input.length <= 2"
                    class="attractive attractive-small uk-margin-right"
                    @click="makeSearch(true)"
                  >
                    Поиск
                  </button>
                  <button
                    :disabled="!searched"
                    class="attractive attractive-small"
                    @click="makeSearch(false)"
                  >
                    Сбросить
                  </button>
                </div>
              </div>

              <div
                  class="catalog__main-items"
                  v-if="catalog.length"
              >
                <a
                    v-for="(item, index) in catalog"
                    :key="index"
                    :href="`/catalog/product/${item.id}`"
                    class="thing catalog__main-item"
                >
                  <div class="thing__symbols"></div>
                  <img
                      v-if="item.file"
                      class="thing__picture"
                      :alt="item.file"
                      :src="getImage('products', item.file)"
                  />
                  <div class="thing__header">{{ item.title }}</div>
                  <div class="thing__features" v-if="item.articles && item.articles.length">
                    Объем:
                    <span
                      v-for="(article, ind) in item.articles"
                      :key="`${item.id || 'p'}-${ind}`"
                    >
                      {{ +article.volume }}{{ 'л' }}<span v-if="ind + 1 < item.articles.length">, </span>
                    </span>
                  </div>
                </a>
              </div>
              <div class="catalog__main-items" v-else>
                <span class="catalog__empty">Товар не найден</span>
              </div>
            </template>
          </div>
        </div>

        <pagination
            v-if="countItems > limit"
            :currentPage="thisPage"
            :countItems="countItems"
            :limitItems="limit"
            @switchPage="thisPage = $event.page"
        />

      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../Pagination'
import {
  displayProductTitle,
  fetchProductCategories,
  fetchProducts,
  productVolumes,
  resolveProductFile
} from '../../api/adminBrands'

export default {
  name: 'catalog-list',
  components: {
    Pagination
  },
  computed: {
    selectedCategoryTitle() {
      if (!this.thisCategory || !this.categories) return ''
      for (const tab of this.categories) {
        if (this.sameId(tab.id, this.thisCategory)) return tab.title || ''
        const child = (tab.child || []).find((item) => this.sameId(item.id, this.thisCategory))
        if (child) return child.title || ''
      }
      return ''
    },
    catalogH1() {
      const s = this.$store && this.$store.state ? this.$store.state.seoPage : null
      if (s && s.id && s.h1) {
        return s.h1
      }
      return this.selectedCategoryTitle || this.currentTab || 'Вся продукция'
    },
  },
  data() {
    return {
      loading: false,
      thisPage: 1,
      countItems: null,
      limit: 12,
      categories: null,
      thisCategory: null,
      currentTab: null,
      catalog: [],
      description: {},
      input: '',
      searchQuery: '',
      searched: false,
      openedSidebarTabs: {},
    }
  },
  methods: {
    makeSearch(search) {
      this.thisPage = 1
      this.searched = search?true:false
      this.input = search?this.input:''
      this.searchQuery = this.input
      this.getInitDataProducts()
    },
    hasChildren(tab) {
      return Array.isArray(tab && tab.child) && tab.child.length > 0
    },
    showMoreTabs(event, tab) {
      if (!this.hasChildren(tab)) return
      event.preventDefault()
      event.stopPropagation()
      const key = String(tab.id)
      this.$set
        ? this.$set(this.openedSidebarTabs, key, !this.openedSidebarTabs[key])
        : (this.openedSidebarTabs = {
            ...this.openedSidebarTabs,
            [key]: !this.openedSidebarTabs[key],
          })
    },
    isSidebarTabOpen(tab) {
      if (!this.hasChildren(tab)) return false
      if (Object.prototype.hasOwnProperty.call(this.openedSidebarTabs, String(tab.id))) {
        return !!this.openedSidebarTabs[String(tab.id)]
      }
      return this.openMoreTabs(tab)
    },
    sameId(left, right) {
      return Number(left) === Number(right)
    },
    openMoreTabs(tab) {
      if (!this.hasChildren(tab)) return false
      return !!tab.child.find((child) => this.sameId(child.id, this.thisCategory))
    },
    mapCatalogItem(item) {
      return {
        ...item,
        title: displayProductTitle(item.title),
        file: resolveProductFile(item.file, item.id),
        articles: productVolumes(item.articles),
      }
    },
    selectedCategoryFilter() {
      const id = this.thisCategory
      if (!id || !this.categories) return {}
      for (const tab of this.categories) {
        if (this.sameId(tab.id, id)) return { categoryId: tab.id }
        const child = (tab.child || []).find((item) => this.sameId(item.id, id))
        if (child) return { subtypeId: child.id }
      }
      return { categoryId: id }
    },
    async getInitDataProducts() {
      this.loading = true
      const filter = this.selectedCategoryFilter()
      try {
        const response = await fetchProducts({
          page: this.thisPage,
          limit: this.limit,
          search: this.searched ? this.searchQuery : undefined,
          categoryId: filter.categoryId,
          subtypeId: filter.subtypeId,
        })
        this.catalog = (response.data || []).map((item) => this.mapCatalogItem(item))
        this.countItems = response.count
        this.emitBreadcrumb()
      } catch (e) {
        this.catalog = []
        this.countItems = 0
      }
      setTimeout(() => this.loading = false, 450);
    },
    sortByOrder(a, b) {
      const left = Number.isFinite(Number(a && a.sort_order)) ? Number(a.sort_order) : Number.MAX_SAFE_INTEGER
      const right = Number.isFinite(Number(b && b.sort_order)) ? Number(b.sort_order) : Number.MAX_SAFE_INTEGER
      if (left !== right) return left - right
      return String((a && a.title) || '').localeCompare(String((b && b.title) || ''), 'ru', { sensitivity: 'base' })
    },
    async getInitDataCategories() {
      try {
        const rows = await fetchProductCategories()
        this.categories = rows
          .slice()
          .sort(this.sortByOrder)
          .map((row) => ({
            id: row.id,
            title: row.title,
            sort_order: row.sort_order,
            child: (Array.isArray(row.child)
              ? row.child
              : (Array.isArray(row.children) ? row.children : [])
            ).slice().sort(this.sortByOrder),
          }))
        this.emitBreadcrumb()
      } catch (e) {
        this.categories = []
      }
    },
    emitBreadcrumb() {
      if (!this.thisCategory || !this.categories) return
      const breadcrumb = []
      this.categories.forEach((tab) => {
        if (this.sameId(tab.id, this.thisCategory)) {
          breadcrumb.push({ id: tab.id, title: tab.title })
        }
        const child = (tab.child || []).find((item) => this.sameId(item.id, this.thisCategory))
        if (child) {
          breadcrumb.push({ id: tab.id, title: tab.title })
          breadcrumb.push({ id: child.id, title: child.title })
        }
      })
      if (breadcrumb.length) {
        this.$emit('breadcrumb', { breadcrumb })
      }
    },
    getImage(type, name) {
      return name || ''
    },
    getCurrentTab(tab, flag) {
      if (this.sameId(this.thisCategory, tab.id)) {
        this.currentTab = tab.title
        return flag
      }
      return false
    },
    async getContentPageByCategory() {
      if (!this.thisCategory || !this.categories) {
        this.description = { content: '' }
        return
      }
      let content = ''
      for (const tab of this.categories) {
        if (this.sameId(tab.id, this.thisCategory)) break
        const child = (tab.child || []).find((item) => this.sameId(item.id, this.thisCategory))
        if (child && child.description) {
          content = (child.description)
          break
        }
      }
      this.description = { content }
    }
  },
  watch: {
    thisPage() {
      this.getInitDataProducts();
    },
  },
  async beforeMount() {
    this.currentTab = 'Вся продукция'
    if (this.$route.params.category) {
      this.currentTab = null
      this.thisCategory = +this.$route.params.category
    }
    await this.getInitDataCategories()
    await this.getContentPageByCategory()
    await this.getInitDataProducts()
  },
}
</script>
